import * as Yup from "yup";

export const IndustryEngagementValidation = Yup.object({
    name: Yup.string()
        .required("Name is required")
        .max(255, "Name must be at most 255 characters"),

    date: Yup.date()
        .nullable()
        .typeError("Must be a valid date"),

    notes: Yup.string()
        .nullable()
        .max(500, "Notes must be at most 500 characters"),

    statusId: Yup.string()
        .required("Status is required")
        .length(36, "Must be a valid status"),

    attendeeIds: Yup.array()
        .of(
            Yup.string()
                .length(36, "Must be a valid employee")
        )
        .min(1, "At least one attendee is required")
        .required("Attendees is required"),

    opportunityIds: Yup.array()
        .of(
            Yup.string()
                .length(8, "Must be a valid opportunity")
        )
        .optional(),
});